<template>
  <div class="loadingoverlay" :class="{ 'use-background': useBackground }">
    <div class="loadingoverlay_element">
      <svg
        :width="width"
        :height="height"
        :style="style"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        class="uil-ring-alt"
      >
        <rect
          x="0"
          y="0"
          width="100"
          height="100"
          fill="none"
          class="bk"
        ></rect>
        <circle
          cx="50"
          cy="50"
          r="40"
          stroke="none"
          fill="none"
          stroke-width="10"
          stroke-linecap="round"
        ></circle>
        <circle
          cx="50"
          cy="50"
          r="40"
          fill="none"
          :stroke="color"
          stroke-width="6"
          stroke-linecap="round"
          stroke-dasharray="251.2"
          stroke-dashoffset="0"
        >
          <animate
            attributeName="stroke-dashoffset"
            dur="2s"
            repeatCount="indefinite"
            from="0"
            to="502"
          ></animate>
          <animate
            attributeName="stroke-dasharray"
            dur="2s"
            repeatCount="indefinite"
            values="150.6 100.4;1 250;150.6 100.4"
          ></animate>
        </circle>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: 100
    },
    height: {
      type: [String, Number],
      default: 100
    },
    useBackground: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#8b2243'
    }
  },
  computed: {
    style() {
      return `width: ${this.width || 100}px; height: ${this.height || 100}px;`
    }
  }
}
</script>

<style scoped>
.use-background {
  background: rgba(255, 255, 255, 0.8);
}
.loadingoverlay {
  box-sizing: border-box;
  position: absolute;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: space-around;
  z-index: 1;
  opacity: 0.985401;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.loadingoverlay_element {
  order: 1;
  box-sizing: border-box;
  overflow: visible;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loadingoverlay_element svg {
  width: 100%;
  height: 100%;
}
</style>
